import { FC } from 'react';
import { ChargerType } from '@models';
import { Box } from '@mui/material';
import chargerAc from '@assets/illustrations/charger-ac.png';
import chargerCpo from '@assets/illustrations/charger-cpo.png';
import chargerEasywallbox from '@assets/illustrations/charger-easywallbox.png';

const WIDTH = 80;
const CIRCLE_SIZE = 60;
export interface ILocationChargerImageProps {
	type: ChargerType | 'easyWallbox' | 'image';
	url?: string;
	width?: number;
	circleSize?: number;
}

export const LocationChargerImage: FC<ILocationChargerImageProps> = ({ type, url, width = WIDTH, circleSize = CIRCLE_SIZE }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				width: 1.0,
				minWidth: width,
				maxWidth: width,
				minHeight: width,
				maxHeight: width,
				position: 'relative'
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					minWidth: circleSize,
					maxWidth: circleSize,
					minHeight: circleSize,
					maxHeight: circleSize,
					backgroundColor: 'primary.main',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					borderRadius: '50%',
					zIndex: 1
				}}
			/>
			<Box sx={{ zIndex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				{type === ChargerType.AC && (
					<img src={chargerAc} style={{ padding: 2, paddingLeft: 8, maxHeight: width, width: 'auto', height: '100%' }} />
				)}
				{type === ChargerType.CPO && <img src={chargerCpo} style={{ width: 'auto', height: 100 }} />}
				{type === 'easyWallbox' && (
					<img src={chargerEasywallbox} style={{ padding: 2, maxHeight: width, width: 'auto', height: '100%' }} />
				)}
				{type === 'image' && !!url && <img src={url} style={{ padding: 2, maxHeight: width, width: 'auto', height: '100%' }} />}
			</Box>
		</Box>
	);
};
